function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint react/no-did-update-set-state: "off" */
import React, { PureComponent } from 'react';
import { Button, Select } from '@deephaven/components';
import { getLabelForBooleanFilter, getLabelForDateFilter, getLabelForNumberFilter, getLabelForTextFilter } from '@deephaven/filters';
import { vsTrash } from '@deephaven/icons';
import { TableUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import classNames from 'classnames';
import memoizeOne from 'memoize-one';
import "./AdvancedFilterCreatorFilterItem.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('AdvancedFilterCreatorFilterItem');
export class AdvancedFilterCreatorFilterItem extends PureComponent {
  static getLabelForFilter(columnType, filterType) {
    try {
      if (TableUtils.isNumberType(columnType) || TableUtils.isCharType(columnType)) {
        return getLabelForNumberFilter(filterType);
      }
      if (TableUtils.isTextType(columnType)) {
        return getLabelForTextFilter(filterType);
      }
      if (TableUtils.isDateType(columnType)) {
        return getLabelForDateFilter(filterType);
      }
      if (TableUtils.isBooleanType(columnType)) {
        return getLabelForBooleanFilter(filterType);
      }
      throw new Error("Unrecognized column type: ".concat(columnType));
    } catch (e) {
      log.warn(e);
      return '';
    }
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "typeDropdown", void 0);
    _defineProperty(this, "getCachedIsValid", memoizeOne((column, operation, value, timeZone, tableUtils) => {
      try {
        // We don't want to show an error for an empty value
        return !value || tableUtils.makeAdvancedValueFilter(column, operation, value, timeZone) != null;
      } catch (e) {
        return false;
      }
    }));
    this.handleDelete = this.handleDelete.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.typeDropdown = null;
    var _props$value = props.value,
      _value = _props$value === void 0 ? '' : _props$value,
      filterTypes = props.filterTypes,
      _props$selectedType = props.selectedType,
      selectedType = _props$selectedType === void 0 ? filterTypes[0] : _props$selectedType;
    this.state = {
      selectedType,
      value: _value
    };
  }
  componentDidMount() {
    var _this$typeDropdown;
    (_this$typeDropdown = this.typeDropdown) === null || _this$typeDropdown === void 0 || _this$typeDropdown.focus();
  }
  componentDidUpdate(prevProps) {
    var _this$props = this.props,
      value = _this$props.value,
      selectedType = _this$props.selectedType;
    if (selectedType !== undefined && prevProps.selectedType !== selectedType) {
      this.setState({
        selectedType
      });
    }
    if (value !== undefined && prevProps.value !== value) {
      this.setState({
        value
      });
    }
  }
  handleTypeChange(eventTargetValue) {
    var selectedType = eventTargetValue;
    log.debug2('typeChange', selectedType);
    this.setState({
      selectedType
    });
    var onChange = this.props.onChange;
    var value = this.state.value;
    if (value != null && value.length > 0) {
      // Don't send an update unless there's already a value entered
      onChange(selectedType, value);
    }
  }
  handleValueChange(event) {
    log.debug2('valueChange');
    var value = event.target.value;
    this.setState({
      value
    });
    var onChange = this.props.onChange;
    var selectedType = this.state.selectedType;
    if (selectedType != null) {
      // Don't send an update unless they've already selected a type
      onChange(selectedType, value);
    }
  }
  handleDelete() {
    log.debug('delete');
    var onDelete = this.props.onDelete;
    onDelete();
  }
  render() {
    var _this$props2 = this.props,
      column = _this$props2.column,
      filterTypes = _this$props2.filterTypes,
      formatter = _this$props2.formatter,
      tableUtils = _this$props2.tableUtils;
    var _this$state = this.state,
      selectedType = _this$state.selectedType,
      value = _this$state.value;
    var showValueInput = !TableUtils.isBooleanType(column.type);
    var typeOptionElements = [];
    var isValid = this.getCachedIsValid(column, selectedType, value, formatter.timeZone, tableUtils);
    for (var i = 0; i < filterTypes.length; i += 1) {
      var type = filterTypes[i];
      var label = AdvancedFilterCreatorFilterItem.getLabelForFilter(column.type, type);
      var element = /*#__PURE__*/_jsx("option", {
        value: type,
        children: label
      }, type);
      typeOptionElements.push(element);
    }
    return /*#__PURE__*/_jsx("div", {
      className: "advanced-filter-creator-filter-item",
      children: /*#__PURE__*/_jsxs("div", {
        className: "form-row",
        children: [/*#__PURE__*/_jsx("div", {
          className: "form-group col",
          children: /*#__PURE__*/_jsx(Select, {
            className: "form-control",
            value: selectedType,
            onChange: this.handleTypeChange,
            ref: typeDropdown => {
              this.typeDropdown = typeDropdown;
            },
            children: typeOptionElements
          })
        }), showValueInput && /*#__PURE__*/_jsx("div", {
          className: "form-group col",
          children: /*#__PURE__*/_jsx("div", {
            className: "input-group",
            children: /*#__PURE__*/_jsx("input", {
              type: "text",
              className: classNames('form-control', {
                error: !isValid
              }),
              placeholder: "Enter value",
              value: value,
              onChange: this.handleValueChange
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "form-group col-1 px-0",
          children: /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            className: "w-100 h-100 p-0 m-0",
            onClick: this.handleDelete,
            icon: vsTrash,
            tooltip: "Remove Filter"
          })
        })]
      })
    });
  }
}
export default AdvancedFilterCreatorFilterItem;
//# sourceMappingURL=AdvancedFilterCreatorFilterItem.js.map